import React from 'react';
import { Menu } from 'antd';
import { HomeOutlined, UnorderedListOutlined, RobotOutlined, AudioOutlined, AuditOutlined, SyncOutlined, ToolOutlined, LinkOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';
import type { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

interface NavigationMenuProps {
  onMenuClick?: () => void;
}

interface MenuItemConfig {
  key: string;
  icon: React.ReactNode;
  label: string;
  resource?: string; // Recurso ACL requerido; sin resource = siempre visible
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = usePermissions();

  const handleMenuClick = (path: string) => {
    navigate(path);
    if (onMenuClick) {
      onMenuClick();
    }
  };

  const allItems: MenuItemConfig[] = [
    { key: '/', icon: <HomeOutlined />, label: 'Home' },
    { key: '/transmisiones', icon: <UnorderedListOutlined />, label: 'Listado Gestión Transmisiones', resource: 'GCvsc.Transmisiones.Read' },
    { key: '/reconciliacion', icon: <AuditOutlined />, label: 'Conciliación con datos oficiales', resource: 'GCvsc.Reconciliacion.Read' },
    { key: '/vinculacion-cu2', icon: <LinkOutlined />, label: 'Vinculación CU2', resource: 'GCvsc.Reconciliacion.Read' },
    { key: '/brevo-sync', icon: <SyncOutlined />, label: 'Sincronización Brevo', resource: 'GCvsc.BrevoSync.Read' },
    { key: '/chat', icon: <RobotOutlined />, label: 'KardioChat', resource: 'GCvsc.KardioChat.Read' },
    { key: '/agent', icon: <AudioOutlined />, label: 'Registro agente', resource: 'GCvsc.Agente.Read' },
    { key: '/mejora-cu2', icon: <ToolOutlined />, label: 'Mejora CU2', resource: 'GCvsc.MejoraCU2.Read' },
  ];

  const menuItems: MenuItem[] = allItems
    .filter(item => !item.resource || hasPermission(item.resource))
    .map(item => ({
      key: item.key,
      icon: item.icon,
      label: item.label,
      onClick: () => handleMenuClick(item.key),
    }));

  return (
    <Menu
      mode="inline"
      selectedKeys={[location.pathname]}
      items={menuItems}
      style={{ border: 'none', background: 'transparent' }}
    />
  );
};

export default NavigationMenu;
